import { $monitoring } from "..";

export function useWidgetCreationProgress() {
  return $monitoring.store.select((state) => ({
    isCreating: state.creatingWidgets,
    progress: state.creatingWidgetsProgress,
  }));
}
